import { isLocalUrl } from '../utils';

export default function slideshow() {
  const widgetName = 'slideshow';
  const widgetOpts = slideshowOpts;

  const swiperContainers = `
    <div class="swiper-container swiper-container-images">
      <div class="swiper-wrapper"></div>
    </div>
    <div class="swiper-container swiper-container-content">
      <div class="swiper-wrapper"></div>
      <div class="swiper-nav">
        <div class="swiper-button-prev"></div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>      
  `;

  // Slide Template - Images
  function buildSlideTemplateImages(slide) {
    const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
          <div class="swiper-lazy-preloader"></div>
        </div>
      </div>
    `;

    return template;
  }

  // Slide Template - Content
  function buildSlideTemplateContent(slide) {
    const title = `<h2 class="slide-title">${slide.Title}</h2>`;
    const description = slide.Description
      ? `<p class="slide-description">${slide.Description}</p>`
      : '';

    const buttons = function (btn1, btn1Text, btn2, btn2Text) {
      if (btn1 || btn2) {
        let btnContainer = $('<div class="button-container"></div>');
        if (btn1) {
          btnContainer.append(
            `<a href="${btn1}" ${isLocalUrl(btn1) ? '' : "target='_blank'"} class="button">${btn1Text}</a>`,
          );
        }
        if (btn2) {
          btnContainer.append(
            `<a href="${btn2}" ${isLocalUrl(btn2) ? '' : "target='_blank'"} class="button">${btn2Text}</a>`,
          );
        }
        return btnContainer.prop('outerHTML');
      } else {
        return '';
      }
    };

    const template = `
      <div class="swiper-slide">
        <div class='swiper-content-container ${description ? 'full-height' : ''}'>
          <div class="slide-content">
          ${title}
          ${description}
          </div>
          ${buttons(slide.URL, slide.DetailLinkText, slide.PurchaseURL, slide.PurchaseLinkText)}
        </div>
      </div>
    `;

    return template;
  }

  // Swiper Initialization
  function initSwiper(widgetData) {
    const swiperWidgetImagesWrapper = $(`#${widgetName} .swiper-container-images .swiper-wrapper`);
    const swiperWidgetContentWrapper = $(
      `#${widgetName} .swiper-container-content .swiper-wrapper`,
    );

    widgetData.forEach(function (slide) {
      swiperWidgetImagesWrapper.append(buildSlideTemplateImages(slide));
      swiperWidgetContentWrapper.append(buildSlideTemplateContent(slide));
    });

    const swiperWidgetImages = new Swiper(`#${widgetName} .swiper-container-images`, {
      speed: 300,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      loop: widgetData.length > 1,
      watchOverflow: true,
      spaceBetween: 0,
      centeredSlides: false,
      preloadImages: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      a11y: true,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: `#${widgetName} .swiper-pagination`,
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: `#${widgetName} .swiper-button-next`,
        prevEl: `#${widgetName} .swiper-button-prev`,
      },
    });

    const swiperWidgetContent = new Swiper(`#${widgetName} .swiper-container-content`, {
      speed: 300,
      spaceBetween: 0,
      centeredSlides: false,
      loop: widgetData.length > 1,
      a11y: true,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
    });
    swiperWidgetImages.controller.control = swiperWidgetContent;
    swiperWidgetContent.controller.control = swiperWidgetImages;

    function buttonsTabIndex(swiper) {
      $(`#${widgetName} .swiper-container-content .button`).attr('tabindex', '-1');
      const activeSlide = $(swiper.slides[swiper.activeIndex]);
      activeSlide.find('.button').attr('tabindex', '0');
    }

    buttonsTabIndex(swiperWidgetContent);

    swiperWidgetContent.on('slideChange', function () {
      buttonsTabIndex(swiperWidgetContent);
    });
  }

  function animateSlideshow(widgetName) {
    const slideshow = document.querySelector(`#${widgetName}`);
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          slideshow.classList.add('animate-slide-up');
          observer.unobserve(slideshow);
        }
      });
    });
    observer.observe(slideshow);
  }

  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);
      animateSlideshow(widgetName);
      if (response.Slides.length === 1) {
        $(`#${widgetName}`).addClass('single-slide');
      }
    } else {
      $('body').addClass(`${widgetName}-no-data`);
    }
  });
}
